module.exports = __webpack_public_path__ + "static/media/1POLICY6.d89b88e7.jpg";